import { Component, OnInit, Input, ViewChild, ViewChildren, ElementRef, QueryList, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as $ from 'jquery';
import { Settings } from 'src/app/models/settings.model';
import { ModuleComponent } from '../module/module.component';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() modulesURL: string;
  @Input() modulesPerPage;
  @Input() dashboard: boolean = false;
  @ViewChild('modulescontainer') modulesContainer: ElementRef;
  @ViewChildren('modulecontainer') moduleContainer: QueryList<ElementRef>;
  @ViewChildren('moduleComponent') moduleComponents: QueryList<ModuleComponent>;
  @Input() modules: any[];
  @Input() inPackage: boolean = false;
  @Input() currentUserIsAdmin: boolean = false;
  @Output() deleteClicked = new EventEmitter<any>();
  linesthatcanfitonscreen: number;
  modulesperline: number;
  setTileSizeFunction;
  scrollingFunction;
  coursesfinished = false;
  loading = false;
  @Input() isUserModulesControl = false;
  //idealModuleWidth = 350;
  //moduleTileBodyHeight = 168;
  //tileMargin = 26;
  //idealImageHeight;
  initialloaddone = false;
  sizeAndScrollingEventListenersSet = false;
  //setTileSizeInterval;
  constructor(private modulemanager: ModulemanagementService, private settings: Settings) { }

  get scollingBody(){
    let scrollingbody =  document.getElementById('home-main-wrap');
    if(window.innerWidth <= 767){//767 because that's the value used in home.component.css
      scrollingbody = scrollingbody.parentElement;
    }
    return scrollingbody;
  }

  async ngAfterViewInit() {
    console.log(this.currentUserIsAdmin);
    this.setTileSize(false);
    await this.load();
    this.initialloaddone = true;
    const mythis = this;
    this.setTileSizeFunction = this.setTileSize.bind(this, true);//have to do it this way because if i just set the event listener to this.setTileSize, the "this" becomes window
    this.scrollingFunction = this.scrolling.bind(this);

    window.removeEventListener('resize', this.setTileSizeFunction);

    if(this.modulesURL){
      this.scollingBody.removeEventListener('scroll', this.scrollingFunction);
    }

    //if(!this.sizeAndScrollingEventListenersSet)
    {
      window.addEventListener('resize', this.setTileSizeFunction);
      if (!this.dashboard){

        if(this.modulesURL){
          this.scollingBody.addEventListener('scroll', this.scrollingFunction);
        }
        //this.scollingBody.parentElement.addEventListener('scroll', this.scrollingFunction);
        //this.scollingBody.parentElement.parentElement.addEventListener('scroll', this.scrollingFunction);
      }
      this.sizeAndScrollingEventListenersSet = true;
    }

    setTimeout(() => {
      mythis.setTileSize(false);
    }, 500);
    setTimeout(() => {
      mythis.setTileSize(false);
    }, 1000);
    // setTimeout(() => {
    //   mythis.setTileSize(false);
    // }, 1500);
    // setTimeout(() => {
    //   mythis.setTileSize(false);
    // }, 2000);
    // this.setTileSizeInterval = setInterval(() => {
    //   mythis.setTileSize(false);
    // }, 1000);
  }

  ngOnInit(): void {
    if(this.modules === undefined){
      this.modules = [];
    }
  }

  hasModules() {
    //debugger;
    return this.modules && this.modules.length > 0
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.setTileSizeFunction);
    this.scollingBody.removeEventListener('scroll', this.scrollingFunction);
    // if(this.setTileSizeInterval){
    //   clearInterval(this.setTileSizeInterval);
    // }
  }

  async load() {
    //debugger;
    this.modules = [];
    // while(this.needsMoreCoursesOnScreen() && !this.coursesfinished)
    // {
    //   await this.loadMoreModules();  
    // }
    await this.loadMoreModules();
  }

  async reload() {
    this.modules = [];
    await this.loadMoreModules();
  }

  needsMoreCoursesOnScreen() {
    const s = $(this.scollingBody).scrollTop(),
      d = this.scollingBody.scrollHeight,
      c = $(this.scollingBody).height();

    const scrollPercent = (s / (d - c)) * 100;

    if (scrollPercent > 70) {
      return true;
    }
    else {
      return false;
    }
  }

  scrolling() {

    const mythis = this;
    const scrollingDown = function () {
      //return true;
      var scrollingdown;
      var st = mythis.scollingBody.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > scrollY) {
        scrollingdown = true;
      } else {
        scrollingdown = false;
      }
      scrollY = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      return scrollingdown;
    }

    if (scrollingDown() && this.needsMoreCoursesOnScreen() && !this.coursesfinished && !this.loading) {
      setTimeout(() => {
        this.setTileSize(false);
        this.loadMoreModules();
      }, 500);
    }
  }



  async loadMoreModules() {

    if(this.modulesURL){
      this.modulesPerPage = this.modulesperline * this.linesthatcanfitonscreen * 2;
      if (this.modulesPerPage < 6 && !this.dashboard) {
        this.modulesPerPage = 6;
      }
      else if (this.dashboard) {
        this.modulesPerPage = 4;
      }

      const firstload = this.modules.length == 0;
      if (!this.loading) {
        this.loading = true;

        const data: any = await this.modulemanager.getModules(this.modulesURL, this.modules.length, this.modulesPerPage).toPromise();
        
        //debugger;
        if (data.length > 0) {          
          this.modules.push(...data);
          // setTimeout(this.setComponentSizes.bind(this), 50);
        }
        else {
          this.coursesfinished = true;
        }
        this.loading = false;

      }
    }
    // if(this.modulesperline == 0 || firstload) {
    //   setTimeout(() => {this.setTileSize(false)}, 1000);
    // }
  }

  setModulesPerLine() {
    //return 350;
    const container = this.modulesContainer.nativeElement;
    const containerWidth = $(container).innerWidth();
    const tileWidth = this.moduleContainer.length > 0 ? $(this.moduleContainer.first.nativeElement).outerWidth() : 200;
    const tileHeight = this.moduleComponents.length > 0 ? $(this.moduleContainer.first.nativeElement).outerHeight() : 200;

    const tileGap = 16;

    this.modulesperline = Math.floor(containerWidth / (tileWidth + tileGap));

    this.linesthatcanfitonscreen = $(this.scollingBody).innerHeight() / (tileHeight + tileGap);
    this.linesthatcanfitonscreen = Math.floor(this.linesthatcanfitonscreen);

    //const containerWidth = $('.modulescontainer').innerWidth();//for some reason, this.modulesContainer is not found on the page.
    //this.modulesperline = 1;
    // let computedwidth;
    // let x = 1;
    // for (; true; x++) {
    //   let width = Math.floor((containerWidth - 30 - (this.tileMargin * (x + 1))) / x);
    //   if (width < 250 || x > 4) {
    //     //computedwidth = width;
    //     this.modulesperline = 4;//just in case we can't calculate it, then we'll just hardocode 4 per line since 4 is the maximum anyway
    //     break;
    //   }
    //   else {
    //     computedwidth = width;
    //     this.modulesperline = x - 1;
    //     //this.idealModuleWidth = computedwidth;
    //   }
    // }
    
    
    console.log('modules per line: ' + this.modulesperline);
  }

  async setTileSize(loadMoreIfNecessary: boolean) {

    const container = this.modulesContainer.nativeElement;
    const containerWidth = $(container).innerWidth();
    //const containerWidth = $('.modulescontainer').innerWidth();//for some reason, this.modulesContainer is not found on the page.
    this.setModulesPerLine();

    //this.idealImageHeight = this.settings.moduleImageHeight / this.settings.moduleImageWidth * (this.idealModuleWidth);

    //this.modulesperline = containerWidth / this.idealModuleWidth;
    //this.modulesperline =this.dashboard?4:  Math.floor(this.modulesperline);
    //console.log('modules per line: ' + this.modulesperline);
    //var totalModulesWidth =this.idealModuleWidth * this.modulesperline;
    //var containerPadding = (containerWidth - totalModulesWidth) / 2;

    // this.linesthatcanfitonscreen = $(this.scollingBody).innerHeight() / (this.idealImageHeight + this.moduleTileBodyHeight);
    // this.linesthatcanfitonscreen = Math.floor(this.linesthatcanfitonscreen);
    //console.log('lines that can fit on screen: ' + this.linesthatcanfitonscreen );

    //const mythis = this;
    // this.setComponentSizes();

    if (loadMoreIfNecessary && !this.dashboard) {
      await this.loadMoreModules();
    }
    //$('.module-tile').width(idealwidth);
  }

  deleteClickedFired(module){
    //debugger;
    this.deleteClicked.emit(module);
  }
  
  // setComponentSizes() {
  //   this.moduleComponents.forEach(c => {
  //     c.setSize(this.idealModuleWidth, this.idealModuleWidth, this.idealImageHeight);
  //   });
  // }

}
